import { NgModule } from '@angular/core';

import { PegaRetailModule } from '@ap/pega';

import { ProductOpenenModule } from '../product-openen/product-openen.module';

import { RetailProductOpenenComponent } from './retail-product-openen.component';

@NgModule({
    imports: [PegaRetailModule, ProductOpenenModule],
    exports: [RetailProductOpenenComponent],
    declarations: [RetailProductOpenenComponent],
    bootstrap: [RetailProductOpenenComponent]
})
export class RetailProductOpenenModule {}
